document.querySelectorAll('[data-u-catalog-carousel]').forEach((root) => {
  const rail = root.querySelector('.u-home-products__rail');
  const previous = root.querySelector('[data-u-catalog-prev]');
  const next = root.querySelector('[data-u-catalog-next]');
  if (!rail || !previous || !next) return;
  const sync = () => {
    previous.disabled = rail.scrollLeft <= 2;
    next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
  };
  const move = (direction) => rail.scrollBy({ left: direction * rail.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  rail.addEventListener('scroll', sync, { passive: true });
  new ResizeObserver(sync).observe(rail);
  sync();
});
const header = document.querySelector('[data-uniforms-header]');
if (header) {
  let frame;
  const hero = document.querySelector('.u-hero');
  const updateHeader = (eventScrollTop = 0) => {
    const scrollTop = Math.max(
      window.scrollY || 0,
      document.documentElement.scrollTop || 0,
      document.body.scrollTop || 0,
      eventScrollTop || 0
    );
    const heroHasMoved = hero ? hero.getBoundingClientRect().top < -32 : false;
    header.classList.toggle(
      'is-solid',
      header.hasAttribute('data-force-solid') || scrollTop > 32 || heroHasMoved
    );
  };
  const requestHeaderUpdate = (event) => {
    const target = event?.target;
    const targetScrollTop = target === document
      ? document.scrollingElement?.scrollTop || 0
      : target?.scrollTop || 0;
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(() => updateHeader(targetScrollTop));
  };

  updateHeader();
  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
  document.addEventListener('scroll', requestHeaderUpdate, { passive: true, capture: true });
  window.addEventListener('pageshow', updateHeader);
}
const contact = document.querySelector('[data-uniforms-contact]');
if (contact) {
  const params = new URLSearchParams(location.search);
  ['product','code','color','size'].forEach((key) => {
    const field = contact.querySelector(`[name="contact[${key}]"` + ']');
    if (field && params.get(key)) field.value = params.get(key);
  });
}
document.querySelectorAll('[data-u-product]').forEach((root) => {
  const variants = JSON.parse(root.querySelector('[data-u-variants]')?.textContent || '[]');
  const radios = [...root.querySelectorAll('[data-u-option]')];
  const cta = root.querySelector('[data-u-cta]');
  const groups = [...root.querySelectorAll('[data-u-option-group]')];
  const media = [...root.querySelectorAll('[data-u-media]')];
  const colorIndex = Number(root.dataset.uColorIndex || 0);
  const colorGroup = groups[colorIndex];
  const galleryLabel = root.querySelector('[data-u-gallery-label]');
  const galleryShell = root.querySelector('.u-product__gallery-shell');
  const colorName = root.querySelector('[data-u-color-name]');
  const reset = root.querySelector('[data-u-color-reset]');
  const code = root.querySelector('[data-u-code]');
  const note = root.querySelector('[data-u-selection-note]');
  const price = root.querySelector('[data-u-price]');
  const variantInput = root.querySelector('[data-u-variant-id]');
  const buy = root.querySelector('[data-u-buy]');
  const buyLabel = root.querySelector('[data-u-buy-label]');
  const normalize = (value = '') => value.toLocaleLowerCase().trim();
  const displayCode = (sku = '') => {
    const base = root.dataset.productCode || '';
    if (!sku || !base) return base;
    const colorCode = sku.includes('-') ? sku.split('-')[1] : sku.slice(-4);
    return colorCode ? `${base}-${colorCode}` : base;
  };
  const getChoices = () => groups.map((group) => group.querySelector('input:checked')?.value || null);
  const selectedColor = () => colorGroup?.querySelector('input:checked')?.value || '';

  const colorMap = {
    black:'#151515', nero:'#151515', white:'#f7f7f4', bianco:'#f7f7f4', red:'#e3262e', rosso:'#e3262e',
    orange:'#f2792b', arancione:'#f2792b', yellow:'#f1d61e', giallo:'#f1d61e', green:'#369657', verde:'#369657',
    lime:'#78d64b', blue:'#2369ad', blu:'#2369ad', navy:'#182848', royal:'#2268b2', cyan:'#28acc5',
    turquoise:'#26aec2', turchese:'#26aec2', pink:'#e8a8bc', rosa:'#e8a8bc', fuchsia:'#c62b72', fucsia:'#c62b72',
    purple:'#5d438c', viola:'#5d438c', lilac:'#9b7ab8', lilla:'#9b7ab8', burgundy:'#772838', bordeaux:'#772838',
    maroon:'#6f2637', granata:'#722638', brown:'#76513d', marrone:'#76513d', beige:'#c9ad8b', sand:'#c8b18d',
    sabbia:'#c8b18d', khaki:'#8c8560', kaki:'#8c8560', olive:'#737548', oliva:'#737548', grey:'#777b7e',
    gray:'#777b7e', grigio:'#777b7e', piombo:'#555b61', anthracite:'#41454a', antracite:'#41454a',
    silver:'#b9bec2', argento:'#b9bec2', gold:'#c8a350', oro:'#c8a350', natural:'#ded3bd', naturale:'#ded3bd'
  };
  const swatchColor = (part = '') => {
    const key = normalize(part).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const words = key.split(/[^a-z]+/).filter(Boolean);
    for (const word of words) if (colorMap[word]) return colorMap[word];
    return '#8a8d91';
  };
  root.querySelectorAll('[data-u-color-swatch]').forEach((swatch) => {
    if (swatch.style.getPropertyValue('--u-swatch')) return;
    const parts = (swatch.dataset.colorName || '').split('/').map((part) => swatchColor(part));
    swatch.style.setProperty('--u-swatch', parts.length > 1
      ? `linear-gradient(135deg,${parts[0]} 0 47%,#fff 47% 53%,${parts[1]} 53% 100%)`
      : parts[0]);
  });

  const showMedia = (color = '') => {
    const key = normalize(color);
    let visible = 0;
    media.forEach((item) => {
      const colors = normalize(item.dataset.uColors || '|');
      const show = key ? colors.includes(`|${key}|`) : item.dataset.uWorn === 'true';
      item.hidden = !show;
      if (show) visible += 1;
    });
    if (!visible) {
      const fallback = key
        ? media.find((item) => normalize(item.dataset.uColors || '|').includes(`|${key}|`))
        : media.find((item) => item.classList.contains('is-worn')) || media.find((item) => item.classList.contains('is-general')) || media[0];
      if (fallback) fallback.hidden = false;
    }
    root.dataset.uGalleryMode = key ? 'color' : 'worn';
    if (galleryLabel) galleryLabel.textContent = color || 'INDOSSATO';
    if (colorName) colorName.textContent = color || 'SELEZIONA UN COLORE';
    if (reset) reset.hidden = !key;
    if (note) note.hidden = Boolean(key);
  };

  const syncAvailability = (color = '') => {
    groups.forEach((group, groupIndex) => {
      if (groupIndex === colorIndex) return;
      group.querySelectorAll('input').forEach((input) => {
        const possible = variants.some((variant) => {
          if (color && variant.options[colorIndex] !== color) return false;
          return variant.options[groupIndex] === input.value;
        });
        input.disabled = !possible;
        input.closest('label')?.classList.toggle('is-unavailable', !possible);
      });
      const checked = group.querySelector('input:checked');
      if (checked?.disabled) {
        checked.checked = false;
        const firstAvailable = group.querySelector('input:not(:disabled)');
        if (firstAvailable) firstAvailable.checked = true;
      }
    });
  };

  const update = () => {
    const color = selectedColor();
    syncAvailability(color);
    showMedia(color);
    const choices = getChoices();
    const variant = variants.find((item) => item.options.every((value, index) => value === choices[index]));
    if (variantInput) variantInput.value = variant?.id || '';
    if (buy) {
      buy.disabled = !variant?.available;
      if (buyLabel) buyLabel.textContent = !variant ? buy.dataset.selectLabel : variant.available ? buy.dataset.addLabel : buy.dataset.unavailableLabel;
    }
    if (price && variant && Number.isFinite(variant.price)) {
      price.textContent = new Intl.NumberFormat(root.dataset.uLocale || 'it', {style:'currency',currency:root.dataset.uCurrency || 'EUR'}).format(variant.price / 100);
    }
    const url = new URL(cta.href, location.origin);
    url.searchParams.set('product', root.dataset.productTitle || '');
    url.searchParams.set('code', displayCode(variant?.sku));
    url.searchParams.delete('color');
    url.searchParams.delete('size');
    groups.forEach((group, index) => {
      const name = normalize(group.dataset.uOptionName);
      const value = choices[index];
      if (!value) return;
      if (['color', 'colour', 'colore'].includes(name)) url.searchParams.set('color', value);
      if (['size', 'taglia'].includes(name)) url.searchParams.set('size', value);
    });
    cta.href = url.pathname + url.search;
    if (code) code.textContent = displayCode(variant?.sku);
    const currentUrl = new URL(window.location.href);
    if (variant) currentUrl.searchParams.set('variant', variant.id);
    else currentUrl.searchParams.delete('variant');
    history.replaceState({}, '', `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
  };
  const returnToGalleryStart = () => {
    if (!galleryShell) return;
    const container = document.querySelector('.page-wrapper') || document.scrollingElement;
    if (!container) return;
    const currentTop = container.scrollTop;
    const targetTop = Math.max(0, currentTop + galleryShell.getBoundingClientRect().top - (header?.getBoundingClientRect().height || 0) - 16);
    if (targetTop >= currentTop) return;
    window.requestAnimationFrame(() => container.scrollTo({
      top: targetTop,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
    }));
  };
  radios.forEach((radio) => radio.addEventListener('change', () => {
    update();
    if (radio.closest('[data-u-option-group]') === colorGroup) returnToGalleryStart();
  }));
  reset?.addEventListener('click', () => {
    colorGroup?.querySelectorAll('input').forEach((input) => { input.checked = false; });
    update();
    returnToGalleryStart();
  });
  root.querySelector('.u-product__purchase')?.addEventListener('submit', (event) => {
    if (!variantInput?.value || buy?.disabled) event.preventDefault();
  });
  update();
});
